import { render, staticRenderFns } from "./ConfirmPurchaseForm.vue?vue&type=template&id=908824e6&"
import script from "./ConfirmPurchaseForm.vue?vue&type=script&lang=js&"
export * from "./ConfirmPurchaseForm.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmPurchaseForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports